import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Card, CardBody } from "reactstrap" // Added for styling wrapper
import WaveChart from "pages/Dashboard/WaveChart"

const TicketsMonthlyLineStatistic = ({ tickets }) => {
    const { labels, series, tooltipLabels, totalTickets } = useMemo(() => {
        if (!tickets || tickets.length === 0) {
            return { labels: [], series: [], tooltipLabels: [], totalTickets: 0 };
        }

        const pad = (n) => String(n).padStart(2, "0");
        const weekdayNames = ["S", "M", "T", "W", "Th", "F", "Sa"];

        // --- extract all dates ---
        const parsedDates = tickets
            .map(t => new Date(t.cp_checkout_date || t.cp_checkin_date || t.checkIn))
            .filter(d => !isNaN(d.getTime()));

        if (parsedDates.length === 0) {
            return { labels: [], series: [], tooltipLabels: [], totalTickets: tickets.length };
        }

        // --- build full date range ---
        const minDate = new Date(Math.min(...parsedDates));
        const maxDate = new Date(Math.max(...parsedDates));

        const grouped = {};
        let cursor = new Date(minDate);

        while (cursor <= maxDate) {
            const key = `${cursor.getFullYear()}-${pad(cursor.getMonth() + 1)}-${pad(cursor.getDate())}`;
            grouped[key] = {
                count: 0,
                tooltip: cursor.toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                    weekday: "long"
                }),
                label: weekdayNames[cursor.getDay()]
            };
            cursor.setDate(cursor.getDate() + 1);
        }

        // --- increment for real tickets ---
        tickets.forEach(t => {
            const d = new Date(t.cp_checkout_date || t.cp_checkin_date || t.checkIn);
            if (isNaN(d.getTime())) return;
            const key = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            if (grouped[key]) grouped[key].count++;
        });

        const sortedKeys = Object.keys(grouped).sort();

        return {
            labels: sortedKeys.map(k => grouped[k].label),
            tooltipLabels: sortedKeys.map(k => grouped[k].tooltip),
            series: sortedKeys.map(k => grouped[k].count),
            totalTickets: tickets.length
        };
    }, [tickets]);

    return (
        // Added Card wrapper for Background #3C3C3C
        <Card style={{ backgroundColor: "#3C3C3C", border: "none" }}>
            <CardBody>
                <div className="text-center text-white">
                    <WaveChart
                        title={`Tickets (Total: ${totalTickets})`}
                        labels={labels}
                        tooltipLabels={tooltipLabels}
                        series={series}
                        statName={"Tickets"}
                        color="#FFCA5C" // Passing the Gold Color
                    />
                </div>
            </CardBody>
        </Card>
    )
}

TicketsMonthlyLineStatistic.propTypes = {
    tickets: PropTypes.array.isRequired
}

export default TicketsMonthlyLineStatistic